<template>
  <section class="banner" v-if="interval" id="banner">
    <b-carousel
      v-model="carousel"
      indicator
      :arrow="screenSize >= 768"
      :arrow-hover="true"
      :pause-hover="false"
      :indicator-inside="false"
      animated="slide"
      :autoplay="true"
      :interval="interval"
      indicator-mode="click"
      indicator-position="is-bottom"
      indicator-style="is-lines"
      style="overflow: hidden"
      indicator-custom-size="is-medium"
    >
      <b-carousel-item v-for="(item, i) in banner" :key="i">
        <section style="height: 100%">
          <div
            class="columns reverse-columns"
            style="height: 100%; margin: 0px"
          >
            <div
              class="column is-4 hero is-dark-blue center has-text-left title-card"
            >
              <div class="animate__animated animate__fadeInUp">
                <h1
                  v-if="item.primary.title.length > 0"
                  :class="`mist-${language}-h1`"
                >
                  {{ item.primary.title[0].text }}
                </h1>
                <h4
                  v-if="item.primary.info.length > 0"
                  :class="`mist-${language}-h4 mist-h4`"
                >
                  {{ item.primary.info[0].text }}
                </h4>
                <b-button
                  @click="toPage(item.primary.link[0].text)"
                  v-if="item.primary.button"
                  :class="`mist-${language}-btn mist-btn`"
                  >{{ item.primary.label[0].text }}</b-button
                >
              </div>
            </div>
            <div
              class="column is-8 center animate__animated animate__fadeIn"
              style="padding: 0px"
            >
              <div
                v-if="item.primary.media === 'img'"
                class="img"
                :style="{
                  width: '100%',
                  height: '100%',
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: 'cover',
                  backgroundPosition: '50% 50%',
                  backgroundImage: `url(` + item.primary.img.url + ')',
                }"
              />
              <div style="width: 100%; height: 100%" v-else>
                <div
                  @click="toPage(item.primary.video.embed_url)"
                  style="width: 100%; height: 100%; position: absolute"
                ></div>
                <div
                  ref="video"
                  allow="autoplay"
                  v-html="item.primary.video.html"
                  style="width: 100%; height: 100%"
                ></div>
              </div>
            </div>
          </div>
        </section>
      </b-carousel-item>
    </b-carousel>
  </section>
</template>

<script>
import $ from "jquery";
export default {
  data() {
    return {
      banner: [],
      interval: null,
      carousel: 0,
      screenSize: null,
    };
  },
  computed: {
    ref() {
      return this.$store.getters["cms/ref"];
    },
    language() {
      return this.$store.getters["language/language"];
    },
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize);
    this.getBanner();
    // $(document).scroll(function () {
    //   const height = $(window).scrollTop() + $(window).height();
    //   if ($(`#reservation-section`).length > 0) {
    //     if (height > $(`#reservation-section`).offset().top) {
    //       $(`#reservation-section`)
    //         .addClass("animate__animated animate__fadeInUp")
    //         .removeClass("invisible");
    //     }
    //   }
    // });
    console.log(this.$refs.video);
  },
  watch: {
    language() {
      this.getBanner();
    },
  },
  methods: {
    async getBanner() {
      const params = {
        ref: this.ref,
        q: `[[at(document.tags, ["Banner","${this.language}"])]]`,
      };
      const res = await this.$http.get(
        process.env.VUE_APP_URL + "/api/v2/documents/search",
        { params }
      );
      this.interval = res.data.results[0].data.interval;
      this.banner = res.data.results[0].data.body;
    },
    toPage(url) {
      if (url.startsWith("http")) {
        let win = window.open(url, "_blank");
        win.focus();
      } else {
        this.$router.push(url);
      }
    },
    onResize() {
      this.screenSize =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      console.log(this.screenSize);
    },
  },
};
</script>

<style scoped>
>>> .carousel-item {
  height: calc(100vh - 200px);
}
>>> .carousel .carousel-indicator {
  padding: 26px;
}
.banner {
  padding: 44px 0;
}
.center {
  justify-content: center;
  align-items: end;
  display: flex;
}
.mist-h4 {
  padding: 30px 0 36px 0;
}
.mist-en-h4 {
  font-weight: 600 !important;
}
.mist-btn {
  background-color: #fff;
  height: 55px;
  max-width: 211px;
  font-size: 18px;
  width: 100%;
  border-radius: 0px;
  color: #002a65;
}
.mist-en-btn {
  font-weight: 600 !important;
}
.mist-th-btn {
  font-weight: 500 !important;
}
>>> iframe {
  border: 0;
  width: 100%;
  height: 100%;
}
>>> .carousel .carousel-indicator .indicator-item .indicator-style.is-lines {
  width: 60px;
  height: 6px;
}
>>> .carousel .carousel-indicator .indicator-item.is-active .indicator-style,
.carousel .carousel-indicator .indicator-item .indicator-style:hover {
  background: #0053c6;
  border: 0px solid white;
}
>>> .carousel-arrow .icon {
  color: #0053c6;
}
>>> .carousel-arrow .icon:hover {
  border: 0px solid #00d1b2;
}
>>> .carousel .carousel-indicator .indicator-item .indicator-style {
  border: 0px solid #00d1b2;
  background: #c4c4c4;
}
>>> .carousel-arrow .icon.has-icons-left {
  left: 0.5rem;
}
>>> .carousel-arrow .icon.has-icons-right {
  right: 0.5rem;
}
.title-card {
  padding: 0 40px;
  min-width: 350px;
}
@media (max-width: 1280px) {
  .mist-btn {
    height: 40px;
    font-size: 14px;
  }
  .mist-en-h1 {
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600 !important;
    font-size: 20px !important;
    line-height: 30px !important;
  }
  .mist-en-h4 {
    font-family: Open Sans;
    font-style: normal;
    font-weight: 400 !important;
    font-size: 14px !important;
    line-height: 22px !important;
  }
  .mist-th-h1 {
    font-family: "Prompt", sans-serif;
    font-style: normal;
    font-weight: 600 !important;
    font-size: 24px !important;
    line-height: 30px !important;
  }
}
@media (max-width: 768px) {
  .reverse-columns {
    flex-direction: column-reverse;
    display: flex;
  }
  >>> .carousel-item {
    height: calc(95vh - 150px);
  }
  .img {
    height: 100%;
  }
  .title-card {
    padding: 0 30px;
    min-width: 0px;
  }
  .mist-h4 {
    padding: 8px 0 14px 0;
    font-weight: 400 !important;
  }
  .banner {
    padding: 20px 0;
  }
}
</style>